import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress ResizeObserver loop error (benign warning in dev mode)
const resizeObserverErr = window.onerror;
window.onerror = (message, ...args) => {
  if (message?.includes?.('ResizeObserver loop')) {
    return true;
  }
  return resizeObserverErr?.(message, ...args);
};

window.addEventListener('error', (e) => {
  if (e.message?.includes?.('ResizeObserver loop')) {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
